import { Injectable } from "@angular/core";
import { ISeriesApi } from "../Models/lcharts/src/api/iseries-api";
import { getCanvasDevicePixelRatio } from "../Models/lcharts/src/gui/canvas-utils";
import { Series } from "../Models/lcharts/src/model/series";
import { DGDrawingServiceGlobal, SeriesTypes } from "./DrawingService";

@Injectable({
  providedIn: "root"
})

export class RetracementAccesabilityService {
  public exludes: SeriesTypes[] = [SeriesTypes.BACKGROUND, SeriesTypes.INTERMEDIATE];
  public retracementVerticalLineMap: Map<number, number> = new Map<number, number>();
  public retracementTimeRangeMap: Map<number, retracementTimeRangeCartessians> = new Map<number, retracementTimeRangeCartessians>();
  public activeBars: Map<number, Series<"Bar" | "Candlestick" | "Area" | "Line" | "Histogram">> = new Map<number, Series<"Bar" | "Candlestick" | "Area" | "Line" | "Histogram">>();
  public constructor() {

  }

  public checkAccessability(serieID): boolean {
    let serie = DGDrawingServiceGlobal.drawingService().mapSeriesMap.get(serieID);

    if (!serie) {
      return false;
    }

    if (this.exludes.indexOf(serie.type) > -1) {
      return false
    }

    return true;

  }

  public allowType(type: SeriesTypes): boolean {
    let v = this.exludes.indexOf(SeriesTypes.INTERMEDIATE) == -1;
    return v;
  }


  public removeType(type: SeriesTypes) {
    let index = this.exludes.indexOf(type);

    this.exludes.splice(index, 1)

  }

  public addType(type: SeriesTypes) {
    this.exludes.push(type)
  }


  public addToVerticalMap(search:number,target:number)
  {
    this.retracementVerticalLineMap.set(search,target);
  }

  public getVerticalMap(search:number):number
  {
    return this.retracementVerticalLineMap.get(search);
  }


  addOrUpdateCartessianMap(serieIndex:number,xstart:number,xend:number, priceStart:number, priceEnd:number)
  {
    let range = new retracementTimeRangeCartessians();

//console.log("serieIndex",serieIndex);
    range.startX = xstart;
    range.endX = xend;
    range.priceStart = priceStart;
    range.priceEnd = priceEnd;
    range.serieIndex = serieIndex;

    this.retracementTimeRangeMap.set(serieIndex, range);

    DGDrawingServiceGlobal.drawingService().activeRetracements.retracementsMenu.drawOrUpdateShrinks(range)
  }

  getFromCartessianMap(serieIndex)
  {
    return this.retracementTimeRangeMap.get(serieIndex)
  }

  removeFromCartessianMap(serieIndex)
  {
    this.retracementTimeRangeMap.delete(serieIndex)
  }

}

export class retracementTimeRangeCartessians
{
  startX:number;
  endX:number;
  priceStart:number;
  priceEnd:number;
  serieIndex:number;
}
